export default __webpack_public_path__ + "static/media/plain-sticker-J.d00136c3.png";